import React, { type FC } from 'react'
import { type RouteComponentProps } from '@reach/router'
import { ExportImportPage } from '../pages'

export const ExportImport: FC<RouteComponentProps> = () => {
  return <ExportImportPage />
}

ExportImport.displayName = 'ExportImportRoute'
